import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { ReactNode } from "react";
import { AnimatedButton } from "./AnimatedButton";
const DialogRef = ({
  title,
  children,
  trigger,
  footer,
  contentClass,
  open
}: {
  title: string;
  children?: ReactNode;
  trigger?: ReactNode;
  footer?: ReactNode;
  contentClass?: string
  open?: boolean
}) => {
  return (
    <Dialog defaultOpen={open}>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent className={`bg-white rounded-[10px] ${contentClass}`}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {children}

        <DialogFooter>
          {footer}
        </DialogFooter>
      </DialogContent>
    </Dialog>

  )
}

export default DialogRef